//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "event_shift_card",
  props: {
    shiftCard: {
      default: []
    },
    available_shifts: {
      default: []
    },
    volunteer: {
      default: () => ({over18: false})
    },
    training_completed: {
      default: () => ([])
    },
    settings: {
      default: () => ({})
    },
    load_counter: {
      default: 0
    }
  },
  data() {
    return {}
  },
  created() {
    $('[data-toggle="tooltip"]').tooltip();
    //$('[data-toggle="popover"]').popover();
    // $('#'+this.shiftCard.name + '_stats').popover({
    //   html:true,
    //   trigger:'click',
    //   title: 'Shift Stats',
    //   content:'<p>Popover content.</p>'
    //   });


  },
  methods: {
    click: function () {
      if (this.shiftCard.volunteer_signup_status === 'Approved') frappe.msgprint('Your shift request has been approved.', '', false);
      else if (this.shiftCard.volunteer_signup_status === 'Rejected') frappe.msgprint('Your shift request has been rejected.  Please contact the volunteer team if you have questions.', '', false);
      else this.show_dialog();
    },
    show_dialog: function () {
      let me = this;
      let shift_info = `<p>Are you sure you want to sign up for the shift <strong>${this.shiftCard.event_name} ${this.shiftCard.team} ${this.shiftCard.weekday} ${this.shiftCard.timeslot}</strong>?</p>`;
      let ticket_info = '';
      let special_request_notice = '';
      let training_notice = '';

      if (this.shiftCard.volunteer_signup_status === 'Pending') {
        shift_info = '<div id="status-alert" class="alert alert-danger" role="alert">Your shift application is pending approval.</div>'
      } else if  (this.shiftCard.volunteer_signup_status === 'Approved') {
        shift_info = '<div id="status-alert" class="alert alert-success" role="alert">Your shift application has been approved.</div>'
      }

      //message += '<div id="no-ticket-alert" class="alert alert-warning" role="alert">You don&apos;t have a ticket for this event!</div>';
      if (this.settings.defer_shift_without_ticket) {
        ticket_info += '<div id="no-ticket-approval-alert" class="alert alert-warning" role="alert">Ticket holders get priority over non-ticket holders.  If you haven\'t purchased a ticket, your request will remain pending.  Once you obtain a ticket come back to this shift and mark that you have a ticket.</div>';
      }

      if (this.shiftCard.require_approval) {
        shift_info += '<div id="pending-confirmed-alert" class="alert alert-danger" role="alert">This shift requires team lead approval.  Your shift request will remain pending until it is approved.</div>';
      }
      if (this.settings.defer_shift_with_special) {
        special_request_notice = '<div id="pending-confirmed-alert" class="alert alert-warning" role="alert">Shifts with special requests will require team lead review before the shift is confirmed.</div>';
      }
      if (!this.has_training) {
        training_notice = `<div id="training-alert" class="alert alert-danger" role="alert">You are required to compelete the following training for this shift: <b>${this.shiftCard.training_required}</b></div>`
      }

      this.dialog = new frappe.ui.Dialog({
        title: __('Confirm shift'),
        fields: [
          {
            label: __('Info'),
            fieldtype: 'HTML',
            options: shift_info,
          },
          {
            label: __('I have a ticket'),
            fieldname: 'has_ticket',
            description: "Select this if you have a ticket for this event.",
            fieldtype: 'Check',
            read_only: !this.is_editable,
            default: 0,
          },
          {
            label: __('Ticket Notices'),
            fieldtype: 'HTML',
            options: ticket_info,
            depends_on: 'eval:!doc.has_ticket',
          },
          {
            label: __('Anonymous'),
            fieldname: 'anonymous',
            description: "Select this if you don't want your burner name shared on this site.  Team leads will still have access to your information.",
            fieldtype: 'Check',
            read_only: !this.is_editable,
            default: 0,
          },
          {
            label: __('Special Requests'),
            fieldname: 'special_requests',
            description: "Do you have any special requests related to this shift?",
            fieldtype: 'Small Text',
            read_only: !this.is_editable,
            default: '',
          },
          {
            label: __('Special Request Notice'),
            fieldtype: 'HTML',
            options: special_request_notice
          },
          {
            label: __('Training Notice'),
            fieldtype: 'HTML',
            options: training_notice
          },
        ],
        primary_action_label: this.primary_action_label(),
        primary_action: this.primary_action,
        secondary_action_label: this.secondary_action_label(),
        secondary_action: this.secondary_action
      });
      // if (this.shiftCard.volunteer_signup_status === null) {
      //   this.dialog.show();
      //   return;
      // }
      //load the last assignment shift details.
      frappe.call({
        method: 'event_management.www.event-shifts.index.get_user_shift_details',
        args: {
          shift_name: me.shiftCard.name,
        },
        callback: function (r) {
          let shift_assignment = r.message;
          if (shift_assignment) {
            me.dialog.set_value('has_ticket', shift_assignment.has_ticket);
            me.dialog.set_value('anonymous', shift_assignment.anonymous);
            me.dialog.set_value('special_requests', shift_assignment.special_requests);
          }
          me.dialog.show();
        },
        // freeze the screen until the request is completed
        freeze: true,
        freeze_message: (__('Please wait') + '...')
      });
    },
    confirm_shift: function (has_ticket, anonymous, special_requests) {
      let me = this;
      frappe.call({
        method: 'event_management.www.event-shifts.index.signup',
        args: {
          shift_name: me.shiftCard.name,
          has_ticket: has_ticket,
          anonymous: anonymous,
          special_requests: special_requests,
        },
        callback: function () {
          me.$parent.reload_shifts();
        },
        // freeze the screen until the request is completed
        freeze: true,
        freeze_message: (__('Please wait') + '...')
      });
    },
    withdraw_shift: function () {
      let me = this;
      frappe.confirm('Are you sure you want to withdraw?', () => {
        frappe.call({
          method: 'event_management.www.event-shifts.index.cancel',
          args: {
            shift_name: me.shiftCard.name
          },
          callback: function () {
            me.$parent.reload_shifts();
          },
          // freeze the screen until the request is completed
          freeze: true,
          freeze_message: (__('Please wait') + '...')
        });
      });
    },
    day_of_month: function (date) {
      return moment(date).format("D");
    },
    month_of_year: function (date) {
      return moment(date).format("MMM");
    },
    format_datetime: function (datetime) {
      return moment(datetime).format("YYYY MM DD h:mm a");
    },
    truncate_text: function(text) {
      if(!text) return '';
      if (text.length > 75)
      {
        return text.substring(0, 75) + "...";
      }
      return text;
    },
    primary_action_label: function () {
      return this.shiftCard.volunteer_signup_status === null || this.shiftCard.volunteer_signup_status === 'Withdrawn' ? __('Confirm') : __('Save');
    },
    primary_action: function () {
      this.dialog.hide();
      this.confirm_shift(this.dialog.get_value('has_ticket'), this.dialog.get_value('anonymous'), this.dialog.get_value('special_requests'));
    },
    secondary_action_label: function () {
      return __('Close');
    },
    secondary_action: function () {
      this.dialog.hide();
    }

  },
  computed: {
    is_full: function () {
      return this.shiftCard.volunteer_count >= this.shiftCard.max_volunteers;
    },
    over18: function () {
      if (!this.volunteer) return false;
      return this.volunteer.over18 === 1;
    },
    has_training: function () {
      if (!this.shiftCard.training_required || this.shiftCard.training_required === '') return true;
      let reqArray = this.shiftCard.training_required.split(',');
      for (var i = 0; i < reqArray.length; i++) {
        if (!this.training_completed.find(tc => tc.training === reqArray[i])) return false;
      }
      return true;
    },
    validate_over18_requirement: function () {
      if (this.over18) return true;
      if (this.shiftCard.over18_requirement === 'At Least One' && this.shiftCard.volunteers_over18 > 0) {
          return true;
      }
      if (this.shiftCard.over18_requirement === 'None') {
        return true;
      }
      return false;
    },
    disable_signup: function () {
      if (this.is_full) return true;
      if (!this.validate_over18_requirement) return true;
      //if (this.shiftCard.volunteer_signup_status !== 'Pending' && this.shiftCard.volunteer_signup_status !== 'Withdrawn') return true;
      if (!this.has_training && this.shiftCard.allow_without_training === 0) return true;
      if (this.shiftCard.signup_ends && moment(this.shiftCard.signup_ends).isBefore()) return true;
      if (this.shiftCard.signup_starts && moment(this.shiftCard.signup_starts).isAfter()) return true;
      return false;
    },
    action_label: function () {
      if (this.shiftCard.volunteer_signup_status != null && this.shiftCard.volunteer_signup_status != 'Withdrawn') return this.shiftCard.volunteer_signup_status;
      if (this.is_full) return "Full";
      if (!this.over18 && (this.shiftCard.over18_requirement === 'All' || (this.shiftCard.over18_requirement === 'At least one' && this.shiftCard.volunteers_over18 === 0))) return "Not 18";
      if (!this.has_training && this.shiftCard.allow_without_training == 0) return "Missing Training";
      if (this.shiftCard.volunteers_pending >= this.shiftCard.max_volunteers) return "Wait List";
      return "Sign up";
    },
    action_class: function () {
      if (this.shiftCard.volunteers_pending >= this.shiftCard.max_volunteers) return "btn-warning";
      return "btn-primary";
    },
    shift_duration_text: function () {
      let start = moment(this.shiftCard.shift_start);
      let end = moment(this.shiftCard.shift_end);
      let durationDays = end.diff(start, 'days')
      if (start.day() === end.day()) {
        return start.format("h:mm a") + " to " + end.format("h:mm a")
      } else if(start.day() != end.day() && durationDays <=6) {
        return start.format("h:mm a") + " to " + end.format("ddd h:mm a")
      }
      return start.format("h:mm a") + " to " + end.format("YYYY MM DD h:mm a")
    },
    show_withdraw: function () {
      if (this.shiftCard.volunteer_signup_status != 'Pending' && this.shiftCard.volunteer_signup_status != 'Approved') return false;
      return true;
    },
    disable_withdraw: function () {
      if (this.shiftCard.volunteer_signup_status != 'Pending' && this.shiftCard.volunteer_signup_status != 'Approved') return true;
      if (this.shiftCard.signup_ends && moment(this.shiftCard.signup_ends).isBefore()) return true;
      return false;
    },
    is_editable: function() {
      if (this.shiftCard.volunteer_signup_status === 'Pending') return true;
      if (this.shiftCard.volunteer_signup_status === 'Withdrawn') return true;
      if (this.shiftCard.volunteer_signup_status === null) return true;
      return false;
    },
    signup_icon: function () {
      if (this.shiftCard.volunteer_signup_status=='Pending') return ["fas", "triangle-exclamation"];
      if (this.shiftCard.volunteer_signup_status=='Approved') return ["fas", "check"];
      if (this.shiftCard.volunteer_signup_status=='Rejected') return ["fas", "xmark"];
      if (this.shiftCard.volunteer_signup_status=='Withdrawn') return ["fas", "pencil"];
      if (this.shiftCard.volunteer_signup_status==null) return ["fas", "pencil"];
      return null
    }

  },
}
